module.exports = __webpack_public_path__ + "img/william-still.1cf62c38.png";